import { useEffect, useState } from "react";
import MediaEpisodeMataDataEditForm from "../../MediaEpisodeMataDataEditForm"
import { utility } from "../../../../framework/utility/utilityProvider";
import underscore from "underscore";
import SaveButton from "../../../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../../../framework/forms/helpercomponents/buttons/CancelButton";
import { ENTITYNAME, TOAST_TYPES } from "../../../../framework/constant/constant";
import * as API from '../../../../framework/API/api';
import RoundButton from "../../../../framework/forms/helpercomponents/buttons/RoundButton";
import BossDialog from "../../../../components/BossDialog";
import { DataHelper } from "../../../../framework/helper/DataHelper";
import SeasonMetaDataEditForm from "../../SeasonMetaDataEditForm";
import { Checkbox } from "@mui/material";
import ToastNotification from "../../../../components/ToastNotification";
import { useTranslation } from "../../../../locale/useTranslation";

const MetaDataTab = (props) => {

    const none = "N/A";

    const { mediaEpisode = {}, entityName, gridData = [], setGridData, isNodeBrowser, selectedItem = {} } = props;

    const lang = useTranslation();

    const [showEditMetaData, setShowEditMetaData] = useState(false);
    const [metaData, setMetaData] = useState({});
    const [loading, setLoading] = useState(true);
    const [tabNumber, setTabNumber] = useState("1");
    const isHideMetaDataFields = entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season;

    const boxStyle = { margin: "0px 5px", padding: "10px", borderRadius: "10px", backgroundColor: "white" }
    const headingStyle = { fontFamily: "Roboto", fontSize: "16px", fontWeight: "700", letterSpacing: "0.2px", lineHeight: "18px", color: "#191825", padding: "10px 0", marginLeft: "10px" }
    const subHeadingStyle = { fontFamily: "Roboto", fontSize: "14px", fontWeight: "700", letterSpacing: "0.2px", lineHeight: "18px", color: "#191825", margin: "7px 0", padding: 0 }
    const subHeadingDetailStyle = { fontFamily: "Roboto", fontSize: "14px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", padding: 0, marginBottom: "25px" }
    const tableDataStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", padding: "10px 5px" }

    useEffect(() => {
        loadMediaEpisodeMetaData();
    }, [mediaEpisode]);

    const loadMediaEpisodeMetaData = async () => {
        setLoading(true);
        if (isNodeBrowser && selectedItem?.mediaEpisodeMetaData && Object.keys(selectedItem?.mediaEpisodeMetaData)?.length != 0) {
            const metaData = selectedItem?.mediaEpisodeMetaData;
            setMetaData(metaData);
            setLoading(false);
            return;
        }
        if (isHideMetaDataFields) {
            let metaValue = Object.keys(mediaEpisode).length > 0 ? {
                Languages: mediaEpisode?.Languages,
                PGRating: mediaEpisode?.PGRating,
                ProductionYear: mediaEpisode?.ProductionYear,
                Keywords: mediaEpisode?.Keywords,
                Categories: mediaEpisode?.Categories && mediaEpisode?.Categories?.length > 0 ? mediaEpisode?.Categories?.map((item) => {
                    return {
                        _id: item?._id,
                        Name: item?.Name,
                        parent: item?.parent
                    }
                }) : [],
                Extension: mediaEpisode?.Extension
            } : {};
            setMetaData(metaValue);
            setLoading(false);
            return;
        }
        let responseMetaData = await API.getData(ENTITYNAME.MediaEpisodeMetaData, { query: ['MediaEpisodeSID', '=', mediaEpisode?.SID] });
        if (responseMetaData.success && responseMetaData.data.length > 0) {
            setMetaData(responseMetaData.data[0]);
        }
        setLoading(false);
    }

    const onCloseMetaData = () => {
        setShowEditMetaData(!showEditMetaData);
    }

    const castAndCrew = underscore.groupBy(metaData?.CastAndCrew, (CastAndCrew) => CastAndCrew?.CastType?.Description);

    //from edit form
    const getMetaData = async (data) => {
        setMetaData(data);
    }

    const onSaveMetadata = async () => {

        if (isNodeBrowser) {
            let metaDataStr = DataHelper.saveMetaDataEntity(metaData, mediaEpisode);
            delete metaDataStr._id;
            delete metaDataStr.SID;
            let finalData = {
                _id: selectedItem?._id,
                mediaEpisodeMetaData: metaDataStr
            }
            let response = await API.saveData(ENTITYNAME.Transmissions, finalData);
            if (!response.success) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                return;
            }
            let updateData = gridData.map((obj) => {
                if (obj._id == selectedItem?._id) {
                    return { ...obj, mediaEpisodeMetaData: response.data.mediaEpisodeMetaData };
                }
                return obj;
            })
            setGridData(updateData);
            onCloseMetaData();
            return;
        }

        if (isHideMetaDataFields) {
            let finalData = {
                ...mediaEpisode,
                Languages: metaData?.Languages?.length > 0 ? metaData.Languages?.map(x => { return { _id: x._id, Description: x.Description } }) : [],
                PGRating: (metaData?.PGRating && Object.keys(metaData.PGRating).length > 0) ? { _id: metaData.PGRating?._id, Description: metaData.PGRating?.Description } : {},
                ProductionYear: metaData?.ProductionYear,
                Keywords: metaData?.Keywords,
                Categories: metaData?.Categories && metaData?.Categories?.length > 0 ? metaData?.Categories?.map((item) => {
                    return {
                        _id: item?._id,
                        Name: item?.Name,
                        parent: item?.parent
                    }
                }) : [],
                Extension: metaData?.Extension
            }
            let response = await API.saveData(entityName, finalData);
            if (!response.success) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                return;
            }
            let updateData = gridData.map((obj) => {
                if (obj.SID == mediaEpisode?.SID) {
                    return { ...obj, ...response.data };
                }
                return obj;
            })
            setGridData(updateData);
        } else {
            let finalData = DataHelper.saveMetaDataEntity(metaData, mediaEpisode);
            let response = await API.saveData(ENTITYNAME.MediaEpisodeMetaData, finalData);
            if (!response.success) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                return;
            }
            let updateData = gridData.map((obj) => {
                if (obj.SID == mediaEpisode?.SID) {
                    return { ...obj, Metadata: response.data };
                }
                return obj;
            })
            setGridData(updateData);

        }
        onCloseMetaData();
    }

    return (
        loading ? <div style={{ ...boxStyle, height: "200px", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <i className="fa fa-spinner fa-spin fa-xl " />
        </div> :
            <>
                {/* Genral */}
                <div style={boxStyle}>
                    <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <h1 style={headingStyle}>GENERAL</h1>
                        </div>
                        <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("1"); }} />
                    </div>
                    {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                        <h1 style={headingStyle}>General</h1>
                        <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("1"); }} />
                    </div> */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                        <div>
                            <h2 style={subHeadingStyle}>Pg Rating</h2>
                            <p style={subHeadingDetailStyle}>{metaData?.PGRating?.Description ?? none}</p>
                            {!isHideMetaDataFields && <><h2 style={subHeadingStyle}>Censor Rating</h2>
                                <p style={subHeadingDetailStyle}>{metaData?.CensorRating?.Description ?? none}</p></>}
                            <h2 style={subHeadingStyle}>Languages</h2>
                            <p style={subHeadingDetailStyle}>{utility.displayArrayInPipe(metaData?.Languages, 'Description') ?? none}</p>
                            {isHideMetaDataFields && <><h2 style={subHeadingStyle}>Categories</h2>
                                <p style={subHeadingDetailStyle}>{utility.displayArrayInPipe(metaData?.Categories, 'Name') ?? none}</p></>}
                        </div>
                        <div>
                            <h2 style={subHeadingStyle}>Production Year</h2>
                            <p style={subHeadingDetailStyle}>{metaData?.ProductionYear ?? none}</p>
                            <h2 style={subHeadingStyle}>Keywords</h2>
                            <p style={subHeadingDetailStyle}>{metaData?.Keywords?.length == 0 ? none : metaData?.Keywords ?? none}</p>
                            {!isHideMetaDataFields && <><h2 style={subHeadingStyle}>Categories</h2>
                                <p style={subHeadingDetailStyle}>{utility.displayArrayInPipe(metaData?.Categories, 'Name') ?? none}</p></>}
                        </div>
                    </div>

                </div><hr />
                {!isHideMetaDataFields && <>
                    {/* Synopsis */}
                    <div style={boxStyle}>
                        <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <h1 style={headingStyle}>SYNOPSIS</h1>
                            </div>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("2"); }} />
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                            <h1 style={headingStyle}>Synopsis</h1>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("2"); }} />
                        </div> */}

                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Language</th>
                                    <th scope="col">Synopsis</th>
                                </tr>
                            </thead>
                            <tbody>
                                {metaData?.Synopsis?.map((synopsis, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={tableDataStyle}>{synopsis?.Language?.Description}</td>
                                            <td style={tableDataStyle}>{utility.subString(synopsis?.Synopsis, 100)}</td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div><hr />

                    {/* Cast & Crew */}
                    <div style={boxStyle}>
                        <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <h1 style={headingStyle}>CAST & CREW</h1>
                            </div>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("3"); }} />
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                            <h1 style={headingStyle}>Cast & Crew</h1>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("3"); }} />
                        </div> */}

                        {Object.keys(castAndCrew).map((key, index) => {
                            return (<>
                                <h2 style={subHeadingStyle}>{key}</h2>
                                <p style={subHeadingDetailStyle}>{utility.displayArrayInPipe(castAndCrew[key], 'Name') ?? none}</p>
                            </>
                            )
                        })}

                    </div><hr />

                    {/* Audio Track */}
                    <div style={boxStyle}>
                        <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <h1 style={headingStyle}>AUDIO TRACK</h1>
                            </div>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("5"); }} />
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                            <h1 style={headingStyle}>Audio Track</h1>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("5"); }} />
                        </div> */}

                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col">Language</th>
                                    <th scope="col">Track Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {metaData?.AudioTrack?.map((AudioTrack, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={tableDataStyle}>{AudioTrack?.Language?.Description}</td>
                                            <td style={tableDataStyle}>{AudioTrack?.TrackNumber}</td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div><hr />

                    {/* Dynamic Field */}
                    {metaData?.dynamicField && <div style={boxStyle}>
                        <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                <h1 style={headingStyle}>DYNAMIC FIELDS</h1>
                            </div>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("4"); }} />
                        </div>
                        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                            <h1 style={headingStyle}>Dynamic Fields</h1>
                            <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber("4"); }} />
                        </div> */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>

                            {
                                Object.keys(metaData?.dynamicField).map((key, index) => {
                                    if (typeof metaData?.dynamicField[key] == 'object') {
                                        return null;
                                    } else {
                                        return (
                                            <div key={index}>
                                                <h2 style={subHeadingStyle}>{key.toUpperCase()}</h2>
                                                <p style={subHeadingDetailStyle}>{metaData?.dynamicField[key] ?? none}</p>
                                            </div>
                                        )
                                    }
                                })

                            }

                        </div>
                    </div>}  </>}<hr />

                {/* Extension Field */}
                <div style={{ padding: "0px 12px 0px 12px" }}>
                    {/* HEADER */}
                    <div style={{ background: "linear-gradient(90deg, #d2d6f1, #9fa3b8)", color: "#160d0d", height: "42px", borderRadius: "12px 12px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <h1 style={headingStyle}>EXTENSION</h1>
                        </div>
                        <RoundButton icon={'pen'} title={'Edit'} onClick={() => { setShowEditMetaData(true); setTabNumber(entityName === ENTITYNAME.MediaEpisode ? "7" : "4"); }} />
                    </div>
                    {/* BODY */}
                    <div style={{ background: "#ffffff", border: "1px solid #e4e6ef" }}>
                        <div className="row m-0">
                            {[
                                { label: "Working Title", key: "workingTitle" },
                                { label: "Episode Number", key: "episodeNumberForPress" },
                                { label: "Total Episodes", key: "totalEpisodes" },
                                { label: "Content Platform", key: "contentPlatform" },
                                { label: "Origin Countries", key: "originCountries" },
                                { label: "Programme Language Id", key: "programmeLanguageId" },
                                { label: "Image Url 1", key: "imageUrl1", isLink: true },
                                { label: "Image Url 2", key: "imageUrl2", isLink: true },
                                { label: "Deal Reference", key: "dealReference" },
                                { label: "Video Format", key: "videoFormat" },
                                { label: "Short Display Title", key: "shortDisplayTitle" },
                                { label: "Short Display Title Chinese", key: "shortDisplayTitleChinese" },
                                { label: "Audio Language 1", key: "audioLanguage1" },
                                { label: "Audio Language 2", key: "audioLanguage2" },
                                { label: "Closed Caption Format", key: "closedCaptionFileFormat" },
                                { label: "Subtitle File", key: "subtitleFileName" },
                                { label: "Subtitle Languages", key: "subtitleLanguages" },
                                { label: "Game ID", key: "gameId" },
                                { label: "Home Team", key: "homeTeam" },
                                { label: "Away Team", key: "awayTeam" },
                                { label: "Audio Mode", key: "audioMode" },
                                { label: "Audio Track", key: "audioTrack" },
                                { label: "Folder Name", key: "folderName" },
                            ].map((item, i) => (
                                <div
                                    className="col-md-6 p-0"
                                    key={i}
                                    style={{ borderRight: i % 2 === 0 ? "1px solid #e4e6ef" : "none", borderBottom: "1px solid #e4e6ef", }}
                                >
                                    <div style={{ padding: "12px" }}>
                                        {/* <div style={{ fontSize: "11px", color: "black", fontWeight: "600", textTransform: "uppercase", }}>{item.label}</div> */}
                                        <div style={subHeadingStyle}>{item.label}</div>
                                        {/* <div style={{ marginTop: "4px", fontSize: "16px", fontWeight: "700", color: "#707074", wordBreak: "break-word", }}> */}
                                        <div style={{ marginTop: "4px", fontFamily: "Roboto", fontSize: "14px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", wordBreak: "break-word" }}>
                                            {item.isLink && metaData?.Extension?.[item.key] ? (
                                                <span style={{ background: "#eef1ff", padding: "4px 6px", fontSize: "14px", }}>{metaData.Extension[item.key]}</span>
                                            ) : (metaData?.Extension?.[item.key] ?? "")}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {entityName === ENTITYNAME.MediaEpisode && (
                            <div style={{ border: "1px solid #e4e6ef", borderTop: "none", background: "#fff", }}>
                                <div className="row m-0">
                                    {[
                                        {
                                            label: "Validity Start",
                                            value: metaData?.Extension?.validity?.validityStart ? utility.convertMilisecondsToDateString(metaData.Extension.validity.validityStart) : ""
                                        },
                                        {
                                            label: "Validity End",
                                            value: metaData?.Extension?.validity?.validityEnd ? utility.convertMilisecondsToDateString(metaData.Extension.validity.validityEnd) : ""
                                        },
                                        {
                                            label: "Premier Start Date",
                                            value: metaData?.Extension?.validity?.premierStartDate ? utility.convertMilisecondsToDateString(metaData.Extension.validity.premierStartDate) : ""
                                        },
                                        {
                                            label: "Premier Start Time",
                                            value: metaData?.Extension?.validity?.premierStartTime ? utility.convertMilisecondsToShortTimeString(metaData.Extension.validity.premierStartTime) : ""
                                        },
                                        {
                                            label: "Premier End Date",
                                            value: metaData?.Extension?.validity?.premierEndDate ? utility.convertMilisecondsToDateString(metaData.Extension.validity.premierEndDate) : ""
                                        },
                                        {
                                            label: "Premier End Time",
                                            value: metaData?.Extension?.validity?.premierEndTime ? utility.convertMilisecondsToShortTimeString(metaData.Extension.validity.premierEndTime) : ""
                                        }
                                    ].map((item, i) => (
                                        <div
                                            className="col-md-6 p-0"
                                            key={i}
                                            style={{ borderRight: i % 2 === 0 ? "1px solid #e4e6ef" : "none", borderBottom: "1px solid #e4e6ef", }}
                                        >
                                            <div style={{ padding: "12px" }}>
                                                <div style={subHeadingStyle}>{item.label}</div>
                                                <div style={{ marginTop: "4px", fontFamily: "Roboto", fontSize: "14px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", wordBreak: "break-word" }}>{item.value}</div>
                                                {/* <div style={{ marginTop: "4px", fontSize: "16px", fontWeight: "700", color: "#707074", wordBreak: "break-word", }}>{item.value}</div> */}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <div style={{ border: "1px solid #e4e6ef", borderTop: "none", background: "#fff", marginBottom: "20px" }}>
                            <div className="row m-0">
                                {[
                                    { label: "Cable VOD", key: "cableVOD" },
                                    { label: "IPTV VOD", key: "iptvVOD" },
                                    { label: "Internet VOD", key: "internetVOD" },
                                    { label: "OTT VOD", key: "ottVOD" },
                                    { label: "Download Video", key: "downloadVideo" },
                                    { label: "SSAI VOD", key: "ssaiVOD" },
                                    { label: "Thumbnail Required", key: "thumbnailRequiredFlag" },
                                    { label: "New Title", key: "newTitle" },
                                    { label: "Subtitle Embedded", key: "subtitleEmbedded" },
                                    { label: "Censorship", key: "censorship" },
                                    { label: "ETV Display", key: "etvDisplay" },
                                    { label: "Start Over", key: "isStartOver" },
                                ].map((item, i) => (
                                    <div
                                        className="col-md-4 p-0"
                                        key={i}
                                        style={{ borderRight: (i % 3 !== 2) ? "1px solid #e4e6ef" : "none", borderBottom: "1px solid #e4e6ef", }}
                                    >
                                        <div style={{ padding: "10px", display: "flex", alignItems: "center", gap: "8px", }}>
                                            <input
                                                checked={metaData?.Extension?.[item.key] || false}
                                                type='checkbox'
                                                // disabled
                                                style={{ border: "1px solid black" }}
                                            />
                                            {/* <span style={{ fontSize: "14px", color: "black", fontWeight: "600" }}> */}
                                            <span style={subHeadingStyle}>
                                                {item.label}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {showEditMetaData && <BossDialog
                    title={'Edit Meta Data'}
                    onClose={onCloseMetaData}
                    width={"900px"}
                >
                    <SaveButton onClick={onSaveMetadata}></SaveButton>
                    <CancelButton onClick={onCloseMetaData}></CancelButton>
                    <div className="mt-3"></div>
                    {isHideMetaDataFields ?
                        <SeasonMetaDataEditForm tabNumber={tabNumber} dataItem={metaData} setMataData={getMetaData} /> :
                        <MediaEpisodeMataDataEditForm tabNumber={tabNumber} getMetaData={getMetaData} metaData={metaData} />}
                </BossDialog>
                }
            </>

    )
}

export default MetaDataTab;